module.exports = __webpack_public_path__ + "img/tan.5165f246.png";